import { get } from "@green24/npm-javascript-utils";
import { M_Selector_DefaultOptions } from "../../models/Models_Selector";

export class Selector {
	/**
	 * @constructor
	 * @param {string} rootPath
	 * @param {M_Selector_DefaultOptions} options
	 */
	constructor(rootPath, options) {
		this._rootPath = rootPath;

		this._options = {
			...M_Selector_DefaultOptions,
			...options,
		}
	}

	static get model() {
		return {
			defaultOptions: M_Selector_DefaultOptions,
		}
	}

	get options() {
		return this._options;
	}

	setState(state) {
		this._state = state;
	}

	selectRoot(state = this._state) {
		return Selector.selectRoot(state, this._rootPath);
	}

	static selectRoot(state, rootPath) {
		return get(state, rootPath);
	}

	selectData(state = this._state, editOnly = undefined) {
		return Selector.selectData(state, this._rootPath, editOnly === undefined ? this.options.editOnly : editOnly);
	}

	static selectData(state, rootPath, editOnly) {
		const root = Selector.selectRoot(state, rootPath);
		const isEditOnly = editOnly === undefined ? root.editOnly : editOnly;

		return get(root, isEditOnly ? "edit" : "data");
	}

	selectEdit(state = this._state) {
		return Selector.selectEdit(state, this._rootPath);
	}

	static selectEdit(state, rootPath) {
		return get(Selector.selectRoot(state, rootPath), "edit");
	}

	selectStates(state = this._state) {
		return Selector.selectStates(state, this._rootPath);
	}

	static selectStates(state, rootPath) {
		const {fetching, fetched, failed, error, deleted, sending} = Selector.selectRoot(state, rootPath) || {};
		return {fetching, fetched, failed, error, deleted, sending};
	}
}
